








export default function getSelectedLabel({
  addonValue,
  selectedNumber,
  selectedValue,
  options
}) {
  if (!addonValue || !options) return null;

  if (selectedNumber === 1) {
    if (!addonValue[0]) return null;
    const selected = options.find(
      (option) => option.value === addonValue[0].value
    );
    return selected ? selected.label : '';
  }

  if (selectedNumber > 1) {
    if (!selectedValue) return null;
    return `(${selectedValue.length}) Selected`;
  }

  return null;
}